<template>
  <div style="margin-top: -20px;display: flex">
    <el-input style="width: 15%" v-model="shuru" placeholder="请输入角色名" clearable/>&nbsp;&nbsp;&nbsp;&nbsp;
    <el-button @click="select" type="primary" plain>搜索</el-button>
    <el-button @click="loadding" type="primary" plain>刷新</el-button>
    <el-button @click="xinjian" type="primary" plain >新建角色</el-button>&nbsp;&nbsp;&nbsp;&nbsp;
  </div>

  <div>
    <el-dialog v-model="dialogFormVisible" title="添加角色" :lock-scroll="false"
               width="45%"  draggable>
      <el-form :model="form" ref="form" :rules="rules" status-icon label-width="160px">
        <el-form-item label="角色名称" >
          <el-input v-model="form.roleName"
                    placeholder="请输入角色名称"
                    onkeyup="this.value=this.value.replace(/[, ]/g,'')"
                    style="width: 300px"
                    clearable autocomplete="off" show-word-limit
                    required></el-input>
          <el-input v-model="form.authorityId" type="hidden"/>
          <el-input v-model="form.createBy" type="hidden"/>
        </el-form-item>

<!--        <el-form-item label="可选权限" >-->
<!--          &lt;!&ndash;          <el-tree :data="treeData" :props="defaultProps" @check-change="handleCheckChange" show-checkbox   ></el-tree>&ndash;&gt;-->
<!--          <el-select v-model="selectvalue" placeholder="请选择权限" clearable="handleNodeClick" filterable multiple collapse-tags>-->
<!--            <el-option-->
<!--                v-for="item in treeData"-->
<!--                :key="item.selectvalue"-->
<!--                :label="item.authorityName"-->
<!--                :value="item.authorityId"-->
<!--                @click="handleCheckChange"-->
<!--            >-->
<!--            </el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
        <el-form-item  label="权限设置"  >
          <el-checkbox   v-model="PowercheckAll" @change="SelRoleProper">全选</el-checkbox>
        </el-form-item>
        <el-form-item label-width="135px">
          <el-scrollbar style="height:400px">
            <el-tree :data="treeData"
                     :props="ProperLstProps"
                     show-checkbox
                     node-key="authorityId"
                     highlight-current
                     ref="tree"
                     :default-checked-keys="selectvalue"
                     :default-expand-all="true"
                     :expand-on-click-node="false"
                     @check="ProperChecked">
              <template #default="{ node }" >
                                            <span class="custom-tree-node" >
                                              <span>{{ node.data.authorityName }}</span>
                                            </span>
              </template>
            </el-tree>
          </el-scrollbar>
        </el-form-item>

      </el-form>

      <template #footer>
                      <span class="dialog-footer" >
                        <el-button style="margin-top: -40px" @click="dialogFormVisible = false">关闭</el-button>
                        <el-button style="margin-top: -40px"  type="primary" @click="onSubmit"
                        >确定</el-button
                        >
                      </span>
      </template>
    </el-dialog>
    <el-dialog v-model="dialogVisible" title="编辑角色" :lock-scroll="false"
               width="45%"  draggable>
      <el-form :model="form2" ref="form" :rules="rules" status-icon label-width="160px">
        <el-form-item label="角色名称" >
          <el-input v-model="form2.roleName"
                    placeholder="请输入角色名称"
                    onkeyup="this.value=this.value.replace(/[, ]/g,'')"
                    style="width: 300px"
                    clearable autocomplete="off" show-word-limit
                    required></el-input>
          <el-input v-model="form2.createBy" type="hidden"/>
          <el-input v-model="form2.updateBy" type="hidden"/>
          <el-input v-model="form2.authorityId" type="hidden"/>
          <el-input v-model="form2.createDate" type="hidden"/>
        </el-form-item>

<!--        <el-form-item label="可选权限" >-->
<!--          &lt;!&ndash;          <el-tree :data="treeData" :props="defaultProps" @check="handleCheckChange" show-checkbox node-key="authorityId" :default-checked-keys="authorityKey"></el-tree>&ndash;&gt;-->
<!--          <el-select v-model="selectvalue2" placeholder="请选择权限" clearable="handleNodeClick" filterable multiple style="width: 300px;">-->
<!--            <el-option-->
<!--                v-for="item in treeData"-->
<!--                :key="item.authorityId"-->
<!--                :label="item.authorityName"-->
<!--                :value="item.authorityId"-->
<!--                @click="handleCheckChange"-->
<!--            >-->
<!--            </el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
        <el-form-item  label="权限设置"  >
          <el-checkbox   v-model="PowercheckAll" @change="SelRoleProper">全选</el-checkbox>
        </el-form-item>
        <el-form-item label-width="135px">
          <el-scrollbar style="height:400px">
            <el-tree :data="treeData"
                     :props="ProperLstProps"
                     show-checkbox
                     node-key="authorityId"
                     highlight-current
                     ref="tree"
                     :default-checked-keys="selectvalue2"
                     :default-expand-all="true"
                     :expand-on-click-node="false"
                     @check="ProperChecked">
              <template #default="{ node }" >
                                            <span class="custom-tree-node" >
                                              <span>{{ node.data.authorityName }}</span>
                                            </span>
              </template>
            </el-tree>
          </el-scrollbar>
        </el-form-item>
      </el-form>

      <template #footer>
                      <span class="dialog-footer" >
                        <el-button style="margin-top: -40px" @click="dialogVisible = false">关闭</el-button>
                        <el-button style="margin-top: -40px"  type="primary" @click="save"
                        >确定</el-button
                        >
                      </span>
      </template>
    </el-dialog>
  </div>

  <div style="margin-top: 10px">
    <el-table :data="tablee" border>
      <el-table-column prop="roleName" label="角色名" style="width: auto"></el-table-column>
      <el-table-column prop="createBy" label="创建人" style="width: auto"></el-table-column>
      <el-table-column prop="createDate" label="创建时间" style="width: auto"></el-table-column>
      <!--      <el-table-column prop="authorityId" label="权限" style="width: auto" type="hidden"></el-table-column>-->
      <el-table-column prop="authorityId" label="操作" style="width: auto">
        <template v-slot="scope">
          <el-button type="primary" plain @click="update(scope.row)">编辑</el-button>
                  <el-button type="danger" plain @click="del(scope.row.roleId)">删除</el-button>

        </template>
      </el-table-column>
    </el-table>

    <div class="demonstration" style="margin: 10px 0">
      <el-pagination v-model:currentPage="currentPage"
                     v-model:page-size="pageSize"
                     :page-sizes="[10, 20]"
                     :small="small"
                     :background="background"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="total"
                     :prev="prev"
                     :pager="pager"
                     :next="next"
                     :jumper="jumper"
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"></el-pagination>
    </div>
  </div>
</template>

<script>
import request from "@/util/request";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Role",
  data() {
    const treeData = [];
    return {
      treeData: JSON.parse(JSON.stringify(treeData)),
      defaultProps: {
        children: 'children',
        label: 'authorityName'
      },
      authorityKey:[],
      aa: [],
      tvDepartmentSelArr: [],
      form: {
      },
      form2: {
      },
      name: '',
      typeqqq:[],
      dialogFormVisible: false,
      dialogVisible: false,
      shuru: '',
      session: sessionStorage.getItem("createBy"),
      tablee: [],
      multipleSelection: [],
      show: false,
      currentPage: 1,
      pageSize: 10,
      total: '',
      small: "small",
      background: "background",
      prev: this.currentPage - 1,
      pager: this.currentPage,
      next: this.currentPage + 1,
      jumper: this.currentPage,
      selectvalue: [],
      selectvalue2: [],
      PowercheckAll:false,//判断是否权限全选
      // Properkeys:[1,2],//默认选择的权限
      // ProperSelArr:[],//选择的权限
      selallPower:[],//全选的权限
      ProperLstProps:{
        label: 'authorityName',
      },
    }
  },
  created() {
    this.dialogFormVisible = false
    this.show = false
    // console.log(sessionStorage.getItem("createBy"))
    this.query()
  },
  methods: {
    SelRoleProper(){//权限全选
      // console.log(this.$refs.tree.getCheckedKeys());
      if (this.PowercheckAll !==false) {
        this.$refs.tree.setCheckedKeys(this.selallPower);
        if(this.dialogVisible){
            this.selectvalue2 = this.selallPower;
        }else {
          this.selectvalue = this.selallPower;
        }
      }else{
        if(this.dialogVisible){//编辑
          this.selectvalue2 =[];
        }else {
          this.selectvalue =[];
        }

        this.$refs.tree.setCheckedKeys([]);
      }
    },
    ProperChecked(data,checkedData){
      if (checkedData.checkedKeys != null && checkedData.checkedKeys.length>0) {
        // this.ProperSelArr =checkedData.checkedKeys;
        if(this.dialogVisible){//编辑，获取选中的权限
          this.selectvalue2 =checkedData.checkedKeys;
        }else {
          this.selectvalue =checkedData.checkedKeys;
        }

      }else {
        // this.ProperSelArr = [];
        if(this.dialogVisible){
          this.selectvalue2 = [];
        }else {
          this.selectvalue = [];
        }
      }
      // console.log(this.ProperSelArr)
      console.log(this.selectvalue2)
      console.log(this.selectvalue)
    },
    loadding() {
      this.shuru = ''
      this.dialogFormVisible = false
      this.show = false
      this.currentPage = 1
      this.query()
    },
    xinjian() {
      // this.selectvalue = ;
      this.dialogFormVisible = true
      this.selectvalue = [];
      this.selallPower=[];
      this.PowercheckAll  =false;
      this.form = {
        roleName: '',
      }
      request.post("/Authority/list", {
        // params: {
        //
        // }
      }).then(res => {
        this.treeData = res.data.lists
        // console.log(res.data.lists)
        for (let i = 0; i < res.data.lists.length; i++) {
          this.selallPower.push(res.data.lists[i].authorityId);
        }
      })
    },
    handleCheckChange() {
      console.log(this.selectvalue2)
    },
    onSubmit() {
      sessionStorage.setItem("createBy" , this.session)
      this.form.authorityId = this.selectvalue+"";
      this.form.createBy = sessionStorage.getItem('userName')
      console.log(this.form.authorityId)
      request.post("/role/createRole", this.form ).then(res => {
        this.tablee = res.data
        console.log(this.name)
        this.dialogFormVisible = false
        this.query()
      })
      this.dialogFormVisible = false
    },
    cancel() {
      this.dialogFormVisible = false
    },
    query() {
      let map={
        "page":this.currentPage,
        "size":this.pageSize,
        "roleName":this.roleName
      }
      request.post("/role/list",map).then(res => {
        this.tablee = res.data.lists
        this.total = res.data.total
        for (let i = 0; i < res.data.lists.length; i++) {
          this.tablee[i].createDate = this.formatDate(res.data.lists[i].createDate, "yyyy-MM-dd hh:mm:ss");
        }
        if (res.code === '500') {
          this.dialogVisible = false
        }
      })
    },
    select() {

      let map={
        "page":this.currentPage,
        "size":this.pageSize,
        "roleName":this.shuru
      }
      request.post("/role/list", map).then(res => {
        console.log(res)
        this.tablee = res.data.lists
        this.total = res.data.total
        for (let i = 0; i < res.data.lists.length; i++) {
          this.tablee[i].createDate = this.formatDate(res.data.lists[i].createDate, "yyyy-MM-dd hh:mm:ss");
          // if (res.data.lists[i].authorityId == 1) {
          //   res.data.lists[i].authorityId = "查看"
          // } else if (res.data.lists[i].authorityId == 2) {
          //   res.data.lists[i].authorityId = "修改"
          // } else if (res.data.lists[i].authorityId == 3) {
          //   res.data.lists[i].authorityId = "删除"
          // }
        }
      })
    },
    update(row) {
      console.log(this.selectvalue)
      this.selectvalue2 = [];
      // this.authorityKey=[];
      this.selallPower=[];
      this.PowercheckAll  =false;
      this.form2 = JSON.parse(JSON.stringify(row))
      this.dialogVisible = true;
      for (let i = 0; i < this.form2.authorityId.split(",").length; i++) {
        var s = parseInt(this.form2.authorityId.split(",")[i]);
        this.selectvalue2.push(s)
      }
      console.log(this.form2.authorityId)
      // console.log(this.form2.authorityId.split(","))
      console.log(this.selectvalue2)
      // console.log(this.form2.authorityId.split(","))

      request.post("/Authority/list", {
        // params: {
        //
        // }
      }).then(res => {
        this.treeData = res.data.lists
        // console.log(res.data.lists)
        for (let i = 0; i < res.data.lists.length; i++) {
          this.selallPower.push(res.data.lists[i].authorityId);
        }
      })
    },
    save() {
      console.log("修改表单的值:" + this.selectvalue2)
      // this.form2.createDate = this.formatDate(this.form2.createDate, "yyyy-MM-dd'T'HH:mm:ss.SSSX")
      this.form2.authorityId = this.selectvalue2+""
      // this.form2.authorityId = this.aa+""
     this.form.createBy = sessionStorage.getItem('userName')
      this.form2.updateBy = sessionStorage.getItem('userName')
      console.log(JSON.stringify(this.form2) )
      request.post("/role/update", this.form2 ).then(res => {
        this.dialogVisible = false
        // this.tablee = res.data.lists
        if (res.code === '0') {
          this.query()
        } else {
          this.query()
        }
      })
    },
    del(roleId) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
      request.delete("/role/delete/" + roleId).then(res => {
        if (res.code === '0') {
          this.$message({
            message: '删除成功！',
            type: 'success'
          });
          this.query()
        } else {
          this.$message({
            message: '删除失败！',
            type: 'error'
          });
        }
      })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    load() {
      request.get('/area/list').then(res =>{
        // console.log(res);
        this.treeData= res.data.structList;

      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection)
      for (let i = 0; i < this.multipleSelection.length; i++) {
        this.authorityId =this.multipleSelection[i].authorityId
        this.form.authorityId = this.authorityId
        this.form2.authorityId = this.authorityId
      }
    },
    formatDate(value, fmt) {
      let getDate = new Date(value);
      let o = {
        'M+': getDate.getMonth() + 1,
        'd+': getDate.getDate(),
        'h+': getDate.getHours(),
        'm+': getDate.getMinutes(),
        's+': getDate.getSeconds(),
        'q+': Math.floor((getDate.getMonth() + 3) / 3),
        'S': getDate.getMilliseconds(),
        'N+': getDate.getMonth(),//上个月
        'D+':"01"//当月一号
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      for (let k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
        }
      }
      return fmt;
    },
    handleSizeChange(pageSize) {
      //修改当前每页的数据行数
      this.pageSize=pageSize;
      //数据重新分页
      this.query();
    },
    handleCurrentChange(pageNum) {
      //修改当前的页码
      this.currentPage=pageNum;
      //数据重新分页
      this.query()
    },
  },
}
</script>

<style scoped>
  .el-form-item {
    display: flex;
    --font-size: 14px;
     margin-bottom: 0px;
  }
</style>